<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="title1">The</span><br/> GILDED<br/> CAKE</h1>
<h2 class="description">The golden rules of cake decorating for metallic cakes</h2>
<p class="author">Faye Cahill</p>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher"><a href="http://www.sewandso.co.uk" target="_blank">www.sewandso.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?39b6d79a